import * as React from "react"
import type { SVGProps } from "react"
const SvgInbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 10.86V7.71q0-.43.29-.7a1 1 0 0 1 .71-.3q.42 0 .71.3.3.27.29.7v3.15l.88-.87a1 1 0 0 1 .33-.23 1 1 0 0 1 .38-.06q.18.01.37.09a1 1 0 0 1 .63.92 1 1 0 0 1-.29.7l-2.6 2.6q-.14.15-.32.22a1 1 0 0 1-.38.06 1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.22l-2.6-2.6a1 1 0 0 1-.3-.7q0-.2.08-.37.06-.18.22-.33.3-.3.71-.3a1 1 0 0 1 .71.28zM5 21.71q-.82 0-1.41-.58A2 2 0 0 1 3 19.7v-14q0-.83.59-1.4A2 2 0 0 1 5 3.7h14q.83 0 1.41.6.6.57.59 1.4v14q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h14v-3h-3a5 5 0 0 1-1.79 1.48 4.8 4.8 0 0 1-4.42 0A5 5 0 0 1 8 16.7H5zm7-3q.8 0 1.48-.4.66-.42 1.1-1.1.15-.23.37-.36a1 1 0 0 1 .5-.14H19v-9H5v9h3.55a1 1 0 0 1 .5.14q.23.14.38.36.42.68 1.1 1.1.67.4 1.47.4" />
  </svg>
)
export default SvgInbox
